import * as _ from 'lodash';

export class ResponsibleFinancial {
    _id: String;
    name: String;
    userName: String;

    constructor(data?) {
        this.populate(data);
    }

    populate(data) {
        _.forOwn(data, (value, key) => {
            this[key] = value;
        });
    }

    loadFromServer(r: any) {
        if (r._id != undefined)
            this._id = r._id;

        if (r.name != undefined)
            this.name = r.name;

        if (r.username != undefined)
            this.userName = r.username;

    }
}



// WEBPACK FOOTER //
// ./src/app/models/project/ResponsibleFinancial.model.ts